import type { Resources } from './en';

export const nl: Resources = {
  approvalAgent: { loading: 'Agent laden…', unknown: 'Onbekende agent', deleted: 'Verwijderde agent' },
  companyActivity: {
    failedAction:
      'Een gekoppelde toolactie is mislukt. Het gespreksbericht bestaat; bezorging wordt hier niet bevestigd.',
    messageAction: 'Berichtactie',
    filters: { all: 'Alles', messages: 'Berichten', tasks: 'Taken', system: 'Systeemactiviteit' },
    title: 'Activiteit',
    all: 'Alles',
    messages: 'Berichten',
    tasks: 'Taakdelegaties',
    system: 'Systeemactiviteit',
    filter: 'Activiteit filteren',
    legend:
      'Berichten zijn DMs of kanaalposts van agents. Taakdelegaties dragen werk over. Systeemactiviteit toont tools en platformgebeurtenissen.',
    window:
      'Beperkte weergave: 8 recente runs (eerste 1.000 gebeurtenissen per run) en 8 recente kanalen (50 laatste hoofdberichten per kanaal). Open een gesprek voor threads en historie.',
    empty: 'Geen activiteit in deze weergave voor ‘{{category}}’.',
    partial: 'Sommige bronnen konden niet worden geladen; deze weergave is onvolledig.',
    unavailable: 'Activiteit is niet beschikbaar. Probeer opnieuw zodra de bron kan worden geladen.',
    unknownAgent: 'Agent onbekend',
    unknownTarget: 'Ontvanger onbekend',
    noPreview: 'Geen preview in de beschikbare metadata.',
    attempt: 'Berichtactie · bezorging hier niet bevestigd',
    status: 'Status',
    details: 'Technische details en gekoppeld bewijs',
    openConversation: 'Gesprek openen',
    openRun: 'Run openen',
    task_delegated: 'Taak gedelegeerd',
    task_reported: 'Taakresultaat gerapporteerd',
    active: { messages: 'Berichtactie uitvoeren…', tasks: 'Werk delegeren…' },
    state: {
      completed: 'Voltooid',
      failed: 'Mislukt',
      unconfirmed: 'Resultaat nog niet beschikbaar',
      recorded: 'Vastgelegd',
      posted: 'In gesprek geplaatst',
      queued: 'In de wachtrij',
      running: 'Bezig',
      waiting_children: 'Wacht op gedelegeerd werk',
      awaiting_approval: 'Wacht op goedkeuring',
      awaiting_human: 'Wacht op een persoon',
      scheduled: 'Ingepland',
      cancelled: 'Gestopt',
    },
  },
  chatActivity: {
    readingCard: 'Trello-kaart lezen…',
    searchingCode: 'Code doorzoeken…',
    queued: 'In de wachtrij',
    running: 'Bezig…',
    scheduled: 'Wachten tot de gebruikslimiet vervalt',
    awaiting_approval: 'Wachten op goedkeuring',
    awaiting_human: 'Wachten op je antwoord',
    waiting_children: 'Wachten op gedelegeerde taken',
    completed: 'Afgerond',
    failed: 'Mislukt',
    cancelled: 'Gestopt',
    executing: 'Opdracht uitvoeren…',
    editing: 'Bestand bewerken…',
    reading: 'Informatie lezen…',
    searching: 'Zoeken…',
    repository: 'Met de repository werken…',
    reviewing: 'Wijzigingen controleren…',
    publishing: 'Wijzigingen publiceren…',
    checking: 'CI controleren…',
    saving: 'Informatie opslaan…',
    delegating: 'Taak delegeren…',
    reporting: 'Resultaat rapporteren…',
    tool: 'Tool gebruiken…',
    details_one: 'Details · {{count}} stap',
    details_other: 'Details · {{count}} stappen',
    openRun: 'Run openen',
  },
  register: {
    createWithTrial: 'Account aanmaken · 14 dagen gratis proberen',
    forgot: 'Wachtwoord vergeten?',
    title: 'Account aanmaken',
    checkEmail:
      'Controleer je e-mail en verifieer je adres. Kies daarna een abonnement. Je proefperiode start zodra Stripe je checkout heeft bevestigd.',
    toBilling: 'Verder naar abonnement',
    name: 'Naam',
    email: 'E-mailadres',
    password: 'Wachtwoord (minimaal 12 tekens)',
    terms:
      '14 dagen gratis. Vooraf betaalmethode opgeven; daarna automatische verlenging. Je kiest het maand- of jaartarief na e-mailverificatie.',
    closed:
      'Openbare registratie is nog niet beschikbaar. Gebruik je uitnodiging of vraag een beheerder om toegang.',
    signIn: 'Inloggen',
    resetTitle: 'Wachtwoord herstellen',
    resetDone: 'Je wachtwoord is gewijzigd. Je kunt opnieuw inloggen.',
    resetSent: 'Als dit account bestaat, ontvang je een e-mail om je wachtwoord te herstellen.',
    newPassword: 'Nieuw wachtwoord (minimaal 12 tekens)',
    reset: 'Herstellen',
  },
  support: {
    title: 'Ondersteuning',
    signingIn: 'Bezig met aanmelden…',
    invalidLink: 'Deze aanmeldlink is ongeldig of verlopen.',
    banner: 'Je bekijkt Mandistry als {{name}} voor ondersteuning (alleen lezen, tot {{time}}).',
    signOut: 'Stoppen',
  },
  billing: {
    title: 'Abonnement',
    exempt: 'Deze organisatie heeft gratis toegang.',
    hasAccess: 'Je abonnement geeft toegang.',
    trialUntil: 'Proefperiode tot {{date}}.',
    paidUntil: 'Betaalde toegang tot {{date}}.',
    monthly: 'Maandabonnement',
    yearly: 'Jaarabonnement',
    exclVat: '{{price}} excl. btw',
    korVat: '{{price}} (geen btw berekend)',
    loadingPrice: 'tarief laden',
    choosePlan: 'Kies je abonnement',
    chooseTitle: 'Kies het abonnement dat bij je past',
    chooseSubtitle: '14 dagen gratis, altijd opzegbaar',
    interval: 'Factuurperiode',
    intervalMonth: 'Maandelijks',
    intervalYear: 'Jaarlijks',
    yearDealMonths: '{{months}} maanden gratis',
    yearDealPercent: '{{percent}}% korting',
    popular: 'Meest gekozen',
    perMonthShort: '/ maand',
    billedMonthly: 'maandelijks gefactureerd',
    billedYearly: '{{total}} per jaar gefactureerd, je bespaart {{saved}}',
    noVat: 'geen btw berekend',
    exVat: 'excl. btw',
    upgrade: 'Abonnement bekijken →',
    setup2fa: 'Tweestapsverificatie instellen →',
    choose: 'Kies {{plan}}',
    suggested: 'Gekozen op de website',
    currentPlan: 'Abonnement: {{plan}}',
    planOrg: '{{companies}} companies · {{agents}} agents · {{seats}} gebruikers',
    planRuns: '{{runs}} runs per maand',
    planSandbox: '{{sandbox}} sandbox-uren per maand',
    blurb: {
      starter: 'Voor oprichters die hun eerste agents aan het werk zetten.',
      team: 'Voor kleine teams die echt werk op agents draaien.',
      business: 'Voor bedrijven waar agents onderdeel zijn van de operatie.',
    },
    features: {
      tasks: 'Taken, triggers en cron',
      approvals: 'Goedkeuringen, guardrails en budgetten',
      memory: 'Geheugen, kennisbank en skills',
      subscriptions: 'Claude Code en Codex op je eigen abonnement',
      notifications: 'Meldingen in de app, web push en e-mail',
      everythingStarter: 'Alles van Starter, plus:',
      hireAgents: 'Agents die agents aannemen',
      gitWorkspaces: 'Git-workspaces en pull requests',
      browserFlows: 'Opgenomen browser-flows',
      chatChannels: 'Telegram, Slack en Discord',
      mcp: 'MCP-endpoint en toegangstokens',
      analysis: 'Dagelijkse analyse van run-fouten',
      everythingTeam: 'Alles van Team, plus:',
      audit: 'Auditlog van 3 jaar',
      priority: 'Prioriteitssupport',
      onboarding: 'Onboardingsessie',
    },
    success: {
      title: 'Bedankt, en welkom bij Mandistry!',
      subtitle: 'Je {{plan}}-abonnement is actief. Een bevestiging is onderweg naar {{email}}.',
      subtitleTrial:
        'Je proefperiode van {{plan}} is gestart. Een bevestiging is onderweg naar {{email}}. Vandaag wordt er niets afgeschreven.',
      receipt: 'Jouw bestelling',
      plan: 'Abonnement',
      company: 'Company',
      billedTo: 'Gefactureerd aan',
      trial: 'Gratis proefperiode',
      trialValue: '14 dagen, tot {{date}}',
      today: 'Vandaag afgeschreven',
      firstPayment: 'Eerste betaling',
      firstPaymentValue: '{{amount}} op {{date}}',
      renews: 'Verlengt',
      renewsValue: 'op {{date}}',
      thenMonth: 'daarna elke maand {{amount}}, automatisch',
      thenYear: 'daarna elk jaar {{amount}}, automatisch',
      included: 'Inbegrepen',
      cancelNote: 'Zeg op tot en met {{date}} op en er wordt niets afgeschreven.',
      invoiceNote: 'Je ontvangt bij elke betaling een factuur.',
      nextTitle: 'Zullen we je op weg helpen?',
      nextSubtitle: 'Drie korte stappen naar je eerste resultaat van een agent, ongeveer vijf minuten.',
      steps: {
        provider: { title: 'Koppel een modelprovider', desc: 'Gebruik je eigen API-key of abonnement.' },
        agent: { title: 'Maak je eerste agent', desc: 'Begin met een template en geef hem een taak.' },
        hello: { title: 'Zeg hallo', desc: 'Chat met hem en zie hem werken.' },
      },
      start: 'Begeleide setup starten',
      skip: 'Nu overslaan',
      skipHint: 'Je kunt dit later oppakken via de checklist op Home.',
      confirmingTitle: 'We bevestigen je betaling…',
      confirmingText: 'Dit duurt meestal een paar seconden. Je kunt deze pagina open laten.',
    },
    unlimited: 'onbeperkt',
    usagePeriod: 'Deze periode, tot {{date}}',
    meter: {
      runs: 'Runs',
      sandbox: 'Sandbox-uren',
      agents: 'Agents',
      seats: 'Gebruikers',
      companies: 'Companies',
    },
    managedByOwner: 'Het abonnement van deze company wordt beheerd door de eigenaar van het account.',
    cancelled: 'Opgezegd: je abonnement verlengt niet meer. Toegang blijft tot de einddatum.',
    terms:
      '14 dagen gratis bij je eerste abonnement. Je geeft vooraf een betaalmethode op. Daarna automatische verlenging tegen het gekozen tarief. Opzeggen stopt de volgende verlenging.',
    finishPayment: 'Betaling of kaartverificatie afronden',
    manage: 'Betaalmethode, facturen en opzeggen',
    verificationSent: 'Verificatie-e-mail verstuurd.',
    resendVerification: 'Verificatie-e-mail opnieuw versturen',
    askOwner: 'Vraag de eigenaar van deze organisatie om het abonnement te herstellen.',
    continue: 'Verder naar Mandistry',
    switchOrg: 'Organisatie wisselen',
    chooseOrg: 'Kies een organisatie',
    security: 'Beveiligingsinstellingen',
    signOut: 'Uitloggen',
  },
  secure: {
    title: 'Beveilig je account',
    subtitle:
      'Met je account beheer je de betaling en de gegevens van je company. Daarom vraagt Mandistry owners en admins om tweestapsverificatie. Het kost ongeveer een minuut.',
    steps: {
      install: 'Installeer een authenticator-app zoals 1Password, Google Authenticator of Authy.',
      scan: 'Scan de QR-code en vul de 6-cijferige code in.',
      backup: 'Bewaar je back-upcodes op een veilige plek.',
    },
    start: 'Authenticator-app instellen',
    signedInAs: 'Ingelogd als {{email}}',
    passkey: 'Gebruik liever een passkey',
  },
  composerMode: {
    label: 'Werkwijze',
    inherited: 'Agentinstelling',
    agentDefault: 'agentinstelling',
    plan: 'Eerst een plan',
    planDescription:
      'De agent legt eerst een plan voor en wacht op goedkeuring voordat hij aan de slag gaat.',
    research: 'Webonderzoek',
    researchDescription:
      'Mag tijdens het werk openbare webpagina’s raadplegen (als de runtime dat ondersteunt).',
    auto: 'Auto',
    autoDescription:
      'Keurt bekende veilige acties goed zonder te vragen. Je regels, verplichte bevestigingen en toegangsgrenzen blijven gelden.',
    autoLocked: 'Alleen wie deze agent mag wijzigen kan Auto aanzetten.',
    restore: 'Agentinstellingen herstellen',
    close: 'Gereed',
  },
  permissions: { title: 'Permissies' },
  runControls: {
    plan: {
      planReview: 'Planbeoordeling',
      breakingChangesProposed: 'Brekende wijzigingen voorgesteld',
      risks: 'Risico’s',
      validation: 'Validatie',
      reviewedBy: 'Beoordeeld door',
      planFeedback: 'Feedback op plan',
      approve: 'Goedkeuren',
      requestChanges: 'Wijzigingen vragen',
      reject: 'Afwijzen',
      approvalAppliesToThisVersion:
        'Goedkeuring geldt alleen voor deze versie. Externe acties blijven onder het uitvoeringsbeleid vallen.',
    },
    fields: {
      research: 'Webonderzoek',
      planReview: 'Planbeoordeling',
      execution: 'Uitvoering',
      agentDefault: 'Agentinstelling',
      off: 'Uit',
      on: 'Aan',
      human: 'Mens',
      manager: 'Manager',
      standard: 'Standaard',
      auto: 'Auto',
    },
    info: {
      research:
        "De agent mag tijdens het werk het openbare web onderzoeken (zoeken waar het model dat kan, pagina's lezen) en bewaart de bronnen. Uit: alleen eigen kennis, geheugen en de tools die je hebt gegeven.",
      planReview:
        'Voor het handelen schrijft de agent een plan. Mens: jij keurt het eerst goed. Manager: de manager-agent beoordeelt het (alleen advies, tenzij Auto aan staat). Uit: direct beginnen.',
      execution:
        "Standaard: riskante acties (externe wijzigingen, onbekende shell-commando's, geld) vragen eerst jou. Auto: bekende, niet-destructieve acties binnen de rechten gaan zonder vragen; destructieve blijven vragen.",
    },
    research: 'Webonderzoek',
    auto: 'Automatische uitvoering',
    phases: {
      planning: 'Planning',
      awaiting_review: 'Wacht op beoordeling',
      reviewing: 'Plan beoordelen',
      executing: 'Uitvoering',
      completed: 'Afgerond',
    },
  },
  companies: {
    title: 'Bedrijven',
    subtitle: 'Elk bedrijf is volledig gescheiden: eigen agents, sleutels, budgetten, data en sandboxes.',
    all: 'Alle bedrijven',
    new: 'Nieuw bedrijf',
    open: 'Openen',
    current: 'Huidig',
    name: 'Naam',
    slug: 'Slug',
    slugHint: 'Optioneel. Kleine letters, cijfers en streepjes; leeg = afgeleid van de naam.',
    create: 'Bedrijf aanmaken',
    createBody:
      'Begint leeg: jij wordt eigenaar en stelt providers, modellen en agents in. Er wordt niets gekopieerd uit andere bedrijven.',
    created: '{{name}} aangemaakt',
    renamed: 'Bedrijf bijgewerkt',
    activeRuns: '{{count}} actief',
    pending: '{{count}} open',
    halted: 'Gestopt',
    today: 'vandaag',
    none: 'Je bent nog geen lid van een bedrijf.',
    onlyAdmins: 'Alleen een platformbeheerder kan bedrijven aanmaken.',
    switched: 'Overgeschakeld naar {{name}}',
    delete: 'Bedrijf verwijderen',
    deleteBody:
      'Verwijdert {{name}} definitief: agents, sleutels, budgetten, chats, runs, geheugen, skills, sandboxes en werkruimtes. Lopend werk wordt geannuleerd. Werk dat al naar af/…-branches is gepusht blijft in je repositories; niet-gepusht werk gaat verloren. Dit kan niet ongedaan worden gemaakt.',
    deleteType: 'Typ {{slug}} om te bevestigen',
    deleted: '{{name}} verwijderd',
    deleteLast: 'Je kunt je enige bedrijf niet verwijderen.',
    thisTab: 'Dit tabblad blijft in dit bedrijf; andere tabbladen houden hun eigen bedrijf.',
  },
  runAnalysis: {
    latest: 'Laatste rapport',
    heroOk: 'Alles in orde de afgelopen 24 uur',
    heroIssues_one: '{{count}} probleem vraagt aandacht',
    heroIssues_other: '{{count}} problemen vragen aandacht',
    heroSub: '{{date}} · {{fresh}} nieuw, {{recurring}} terugkerend, {{resolved}} opgelost',
    openReport: 'Rapport openen',
    nextReport: 'Volgend rapport',
    off: 'Uit',
    act: {
      title: 'Voorgestelde acties',
      hint: 'Er gebeurt niets voordat jij goedkeurt.',
      approve: 'Goedkeuren en uitvoeren',
      approveHere: 'Suggestie goedkeuren en uitvoeren',
      approveAll: 'Alles goedkeuren ({{count}})',
      done: 'Klaar',
      confirmTitle_one: 'Deze actie uitvoeren?',
      confirmTitle_other: 'Deze {{count}} acties uitvoeren?',
      confirmBody: 'Elke stap gebruikt je eigen rechten en wordt vastgelegd in het auditlog.',
      restart_runs_one: 'De mislukte run van {{subject}} opnieuw starten (nieuwe run, zelfde invoer)',
      restart_runs_other:
        '{{count}} mislukte runs van {{subject}} opnieuw starten (nieuwe runs, zelfde invoer)',
      cancel_runs_one: 'De vastgelopen run van {{subject}} stoppen',
      cancel_runs_other: '{{count}} vastgelopen runs van {{subject}} stoppen',
      enable_trigger: 'Trigger “{{name}}” weer aanzetten',
      success: '{{count}} stap(pen) uitgevoerd',
      failed: '{{count}} stap(pen) mislukt: {{reason}}',
      open_permissions: 'Rechten van de agent bekijken',
      open_config: 'Limieten van de agent bekijken',
      open_triggers: 'Triggers van de agent openen',
      openApprovals: 'Goedkeuringen openen',
    },
    failingStep: 'Faalstap',
    unknownStep: 'Onbekend',
    kinds: {
      run_failed: 'Gefaalde run',
      run_cancelled: 'Geannuleerde run',
      run_recovered: 'Herstelde run',
      run_stuck: 'Vastgelopen run',
      run_outlier: 'Run-uitschieter',
      tool_error: 'Toolfout',
      tool_denied: 'Geweigerde tool',
      tool_slow: 'Trage tool',
      approval: 'Goedkeuring',
      trigger_skipped: 'Overgeslagen trigger',
      trigger_disabled: 'Uitgeschakelde trigger',
      task_failed: 'Gefaald werk',
      flow_failed: 'Gefaalde flow',
    },
    title: 'Run-analyse',
    subtitle: 'Dagelijkse rapporten van gegroepeerde runfouten',
    run: 'Analyse nu draaien',
    enabled: 'Dagelijkse analyse aan',
    time: 'Tijdstip',
    save: 'Instellingen opslaan',
    schedule: 'Planning',
    allOk: 'Alles ok',
    empty: 'Nog geen rapporten',
    notFound: '404 — Rapport niet gevonden',
    back: 'Alle rapporten',
    more: 'Eerdere rapporten',
    issues: 'Issuegroepen',
    resolved: 'Verdwenen',
    'new': 'Nieuw',
    recurring: 'Terugkerend',
    cause: 'Oorzaak-hypothese',
    proposal: 'Voorstel',
    category: 'Categorie',
    first: 'Eerste keer',
    last: 'Laatste keer',
    count: 'Aantal',
    examples: 'Voorbeeld-runs',
    analysisCost: 'Analysekosten',
    runCost: 'Runkosten',
    model: 'Model',
    tokens: 'Tokens',
    status: 'Analysestatus',
    runs: 'Runs',
    completed: 'Voltooid',
    failed: 'Gefaald',
    cancelled: 'Geannuleerd',
    failureRate: 'Foutpercentage',
    toolCalls: 'Toolaanroepen',
    toolErrors: 'Toolfouten',
    approvalsExpired: 'Verlopen goedkeuringen',
    approvalsDenied: 'Geweigerde goedkeuringen',
    triggersSkipped: 'Overgeslagen triggers',
    triggersDisabled: 'Uitgeschakelde triggers',
    tasksFailed: 'Gefaald werk',
    issueCount: 'Issuegroepen',
    newIssues: 'Nieuwe groepen',
    recurringIssues: 'Terugkerende groepen',
    resolvedIssues: 'Verdwenen groepen',
    pendingHint: 'Voorstellen verschijnen na de volgende worker-tick (maximaal 10 minuten).',
    twoFactor: 'Stel 2FA in bij beveiliging om analyses te draaien of de planning te wijzigen.',
    statuses: {
      pending: 'In afwachting',
      running: 'Bezig',
      done: 'Klaar',
      partial: 'Gedeeltelijk',
      not_needed: 'Niet nodig',
      budget_exceeded: 'Budget overschreden',
      no_model: 'Geen model',
      failed: 'Gefaald',
      skipped: 'Overgeslagen',
    },
    categories: {
      agent_instruction: 'Agent-instructies',
      tool_policy: 'Tool-policy',
      permission_or_integration: 'Rechten of integratie',
      tool_bug: 'Toolbug',
      workflow: 'Workflow',
      infrastructure: 'Infrastructuur',
      other: 'Overig',
    },
  },
  nav: {
    runAnalysis: 'Run-analyse',
    company: 'Bedrijf',
    master: 'Bedrijfschat',
    tasks: 'Taken',
    runs: 'Runs',
    flows: 'Flows',
    skills: 'Skills',
    approvals: 'Goedkeuringen',
    usage: 'Verbruik',
    notifications: 'Meldingen',
    settings: 'Instellingen',
    help: 'Helpcentrum',
    menu: 'Menu',
    main: 'Hoofdnavigatie',
    home: 'Start',
    workspace: 'Werkruimte',
    pin: '{{name}} vastzetten',
    unpin: '{{name}} losmaken',
    switch: 'Wissel',
    newAgent: 'Nieuwe agent',
    shortcuts: 'Sneltoetsen',
  },
  shell: {
    halted: 'GESTOPT — alle agents staan stil. Er starten geen nieuwe runs.',
    resume: 'Hervatten',
    activeRuns: '{{count}} actief',
    spendToday: 'vandaag',
    killSwitch: 'Stop',
    killTitle: 'Alle agents stoppen',
    killBody:
      'Dit annuleert alle lopende jobs, stopt sandboxes en pauzeert alle schedulers van deze organisatie. Typ HALT om te bevestigen.',
    killConfirm: 'Alles stoppen',
    killTypeHalt: 'Typ HALT',
    resumeTitle: 'Organisatie hervatten',
    resumeBody: 'Agents accepteren weer nieuwe runs. Schedulers worden hervat.',
    userMenu: 'Gebruikersmenu',
    switchOrg: 'Wissel van organisatie',
    language: 'Taal',
    signOut: 'Uitloggen',
    commandPalette: 'Opdrachtenpalet',
    twoFaRequired: 'Owners en admins moeten tweestapsverificatie inschakelen.',
    twoFaSetup: 'Nu instellen',
    mockMode: 'MOCK',
    search: 'Zoek alles…',
    searchLabel: 'Zoek alles (⌘K)',
    askAgent: 'Vraag een agent',
    newTask: 'Nieuwe taak',
    inbox: 'Goedkeuringen-inbox',
    toggleSidebar: 'Zijbalk tonen/verbergen',
    bottomNav: 'Snelnavigatie',
    more: 'Meer',
    showPanel: 'Dashboardpaneel tonen',
    hidePanel: 'Dashboardpaneel verbergen',
    skipToContent: 'Naar inhoud',
    dismiss: 'Sluiten',
    announcements: 'Mededelingen',
    haltedCta: 'Bekijk runs',
    priceMissing: 'Prijsgegevens ontbreken voor sommige actieve modellen — de getoonde kosten zijn te laag.',
    priceMissingCta: 'Prijzen instellen',
  },
  palette: {
    placeholder: 'Typ een opdracht of zoek…',
    closePanes: 'Alle open panelen sluiten',
    empty: 'Geen resultaten.',
    navigate: 'Navigeren',
    agents: 'Agents',
    actions: 'Acties',
    newAgent: 'Nieuwe agent',
    newTask: 'Nieuwe taak',
    newChat: 'Nieuwe chat',
    toggleLang: 'Wissel taal (EN/NL)',
    chatWith: 'Chat met {{name}}',
    dev: 'Mock-bediening',
    appearance: 'Weergave',
    theme: 'Thema: {{name}}',
    terminalDark: 'Donkere terminalpanelen aan/uit',
  },
  theme: {
    label: 'Thema',
    system: 'Systeem',
    light: 'Licht',
    dark: 'Donker',
    terminalDark: 'Terminalpanelen donker houden',
  },
  launcher: {
    placeholder: 'Zoek agents, chats, runs, instellingen… (> commando’s, @agent bericht)',
    filterActions: 'Filter acties…',
    results: 'Resultaten',
    commands: 'Commando’s',
    askMode: 'Vraag een agent',
    sendTo: 'Stuur naar {{name}}',
    askAgent: 'Vraag {{name}}…',
    openRuns: 'Runs van {{name}} openen',
    openAgent: '{{name}} openen',
    openRun: 'Run openen',
    chat: 'Chat openen',
    actionsFor: 'Acties voor {{name}}',
    agentFromTemplate: 'Nieuwe agent vanuit een sjabloon',
    resumeAll: 'Alle agents hervatten',
    toggleTheme: 'Wissel licht / donker thema',
    switchOrg: 'Overstappen naar {{name}}',
    noAgent: 'Geen agent gevonden voor “@{{handle}}”.',
    typeMessage: 'Typ een bericht na de agentnaam en druk op ⏎.',
    hintMove: 'navigeer',
    hintOpen: 'open',
    hintDrill: 'acties',
    hintCommands: 'commando’s',
    hintAsk: 'vraag agent',
    group: {
      send: 'Versturen',
      recent: 'Recent',
      setup: 'Aan de slag',
      navigate: 'Ga naar',
      agents: 'Agents',
      conversations: 'Gesprekken',
      runs: 'Runs',
      tasks: 'Taken',
      approvals: 'Wacht op goedkeuring',
      settings: 'Instellingen',
      actions: 'Acties',
      dev: 'Mock-bediening',
    },
  },
  shortcuts: {
    spaceNote: '⌘Spatie is van je besturingssysteem (Spotlight); de launcher zit daarom op ⌘K / Ctrl+K en /.',
    general: 'Algemeen',
    inLauncher: 'In de launcher',
    panes: 'Terminalpanelen',
    goTo: 'Ga naar (druk g, dan de toets)',
    launcher: 'Launcher openen',
    launcherSlash: 'Launcher openen (als je niet typt)',
    ask: 'Een agent iets vragen',
    help: 'Dit overzicht tonen',
    sidebar: 'Zijbalk tonen/verbergen',
    panel: 'Contextpaneel tonen/verbergen',
    move: 'Door resultaten bewegen',
    open: 'Openen / uitvoeren',
    secondary: 'Tweede actie (bijv. chat openen)',
    drill: 'Acties van een agent openen',
    commandMode: 'Commandomodus',
    mention: 'Agent een bericht sturen: @agent bericht',
    back: 'Terug / sluiten',
    interrupt: 'Run van het actieve paneel onderbreken',
    modeLine: 'Goedkeuringsmodus wisselen',
  },
  providers: {
    checkSubscriptionRequest: 'Abonnementsaanroep gecontroleerd',
    checkHybridSubscription: 'Abonnementsaanroep gecontroleerd; API-sleutel niet gecontroleerd',
    checkHybridLogin: 'API-sleutel en modellijst gecontroleerd; persoonlijke logins niet gecontroleerd',
    outcomeUnknown: 'Onbekend — controleer versiehistorie',
    apiKeyStored: 'API-sleutel opgeslagen',
    noApiKeyStored: 'Geen API-sleutel opgeslagen (mogelijk niet vereist)',
    authentication: 'Authenticatie',
    authHybrid: 'Abonnement + API-sleutel',
    authSubscription: 'Abonnement',
    authOwnLogin: 'Persoonlijke Claude-login · account van agentmaker',
    authChatgpt: 'ChatGPT-verbinding · Codex-runtime',
    authToken: 'Setup-token · Claude Code-runtime',
    statusDisabled: 'Uitgeschakeld',
    checkLogin: 'Alleen jouw login gecontroleerd; agentmakers loggen apart in; geen modelaanroep',
    checkCatalog: 'Account en modellijst gecontroleerd; geen modeluitvoering',
    checkRequest: 'Modellijst gecontroleerd; geen modeluitvoering',
    bulkModel: 'Bulksnelkoppeling',
    bulkApply: 'Vul lege geselecteerde doelen',
    targetFor: 'Nieuw model voor {{name}}',
    unchanged: 'Ongewijzigd',
    moveDone: 'Verplaatst · wordt niet opnieuw geprobeerd',
    moveConflict: 'Agent gewijzigd. Open dit venster opnieuw om de huidige instellingen te bekijken.',
    moveUncertain:
      'Uitkomst onbekend: antwoord verloren of serverfout. Opnieuw proberen is geblokkeerd; controleer de versiehistorie voordat je heropent. Andere agents kun je opnieuw proberen.',
    moveRemaining:
      'Er zijn nog agents afhankelijk van deze provider. Selecteer en verplaats ze allemaal voordat je uitschakelt, of kies expliciet uitschakelen zonder verplaatsen.',
    moveSuccess: '{{count}} agent(s) verplaatst',

    saveAndConnect: 'Opslaan en ChatGPT koppelen',
    moveChangelog: 'Verplaatst van {{from}} naar {{to}}',
    moved: '{{count}} agent(s) gebruiken nu {{model}}',
    movedPartial: '{{count}} verplaatst voor de fout',
    disableTitle: '{{name}} uitzetten?',
    disableBody:
      '{{count}} agent(s) gebruiken deze provider voor een primair model of terugvalmodel. Uitzetten maakt die modellen onbeschikbaar. Verplaats eerst primaire modellen en pas terugvalinstellingen aan.',
    moveTitle: 'Agents verplaatsen weg van {{name}}',
    moveBody: '{{count}} agent(s) gebruiken nu een model van deze provider.',
    fallbackDependency:
      'Sommige agents gebruiken deze provider alleen als terugvalmodel. Een ander primair model behoudt dat terugvalmodel. Pas eerst hun terugvalinstellingen aan of zet expliciet uit zonder verplaatsen; dat terugvalmodel is dan niet beschikbaar.',
    disableAnyway: 'Uitzetten zonder verplaatsen',
    moveAndDisable: 'Verplaats agents en zet uit',
    moveAgents: 'Agents verplaatsen',
    moveTo: 'Nieuw model',
    pickModel: 'Kies een model…',
    noAlternative:
      'Er is geen andere ingeschakelde provider met een model. Voeg er eerst een toe of zet er een aan.',
    runtimeNote:
      '{{count}} agent(s) gebruiken een runtime die alleen met deze provider werkt; ze gaan over op de standaard AI SDK-runtime.',
    undoHint:
      'Elke verplaatsing is een nieuwe agentversie: zet het oude model altijd terug via de versiegeschiedenis van de agent.',
    statusNever: 'Nog niet getest',
    statusOk: 'Controle geslaagd',
    statusFail: 'Mislukt',
    statusModels: '{{count}} modellen',
    statusChecked: 'gecontroleerd {{when}}',
    statusSubscription: 'Abonnement geverifieerd',
    testNow: 'Test',
    moveAgentsBtn: 'Agents verplaatsen ({{count}})',
    connectChatgpt: 'ChatGPT-abonnement',
    connectChatgptHint:
      'Codex-agents gebruiken je ChatGPT-plan in plaats van een API-key. Na het opslaan log je in met een korte code.',
    payApi: 'API-key',
    payApiHint: 'Betaal per token. Werkt voor elke runtime.',
    codexPay: 'Codex-runtime: hoe betalen',
    claudePay: 'Claude Code-runtime: hoe betalen',
    claudeLoginHybrid: 'Je Claude-account, API-key als reserve',
    claudeLoginHybridHint:
      'Claude Code draait in de eigen sandbox van elke agent op het Claude-account van wie de agent maakte; bij de limiet of zonder login neemt de API-key het over.',
    claudeLoginOnly: 'Alleen je Claude-account',
    claudeLoginOnlyHint:
      'Claude Code draait in de eigen sandbox van elke agent op het Claude-account van de maker en wacht bij de limiet. Andere runtimes hebben nog steeds een API-key nodig.',
    claudeLoginTerms:
      'Het gebruik telt mee voor de limieten van je eigen Claude-abonnement en valt onder de voorwaarden van Anthropic. Iedereen logt in met een eigen account; agents gebruiken dat van hun maker.',
    claudeLoginButton: 'Je Claude-account',
    maxCreditsHint:
      'Heb je Claude Max? Daar zit $100–200 per maand aan API-credits bij: maak een key in de Claude Console.',
    maxCreditsLink: 'Zo werkt het',
    chatgptWaitlist: 'Laat het me weten als het kan',
    chatgptWaitlistJoined: 'Je staat op de lijst',
    creditBudget: 'Maandbudget (optioneel)',
    creditBudgetHint:
      'Beperkt de uitgaven van het hele bedrijf per maand (alle providers): een waarschuwing bij 80%, runs stoppen bij 100%.',
    creditBudgetNone: 'Budget niet wijzigen',
    creditBudgetMax5: '$100 per maand (Max 5x-credit)',
    creditBudgetMax20: '$200 per maand (Max 20x-credit)',
    chatgptSoon:
      'ChatGPT-abonnement: binnenkort. Codex op een ChatGPT-abonnement in een gehoste app vraagt goedkeuring van OpenAI, die we hebben aangevraagd. Tot die tijd gebruikt Codex een API-key.',
  },
  claudeLogin: {
    title: 'Je Claude-account',
    intro:
      'Claude Code logt zelf in, via de eigen pagina van Anthropic, in een afgeschermde container. Mandistry ziet je wachtwoord of token nooit: de login blijft bij Claude Code in je sandbox.',
    who: 'Je agents (die jij hebt gemaakt) draaien op dit account. Collega’s loggen in met hun eigen account.',
    start: 'Claude Code laten inloggen',
    restart: 'Claude Code opnieuw laten inloggen',
    starting: 'Claude Code starten…',
    open: 'Open de inlogpagina van Anthropic',
    paste: 'Na het inloggen toont Anthropic een code. Plak die hier:',
    codeLabel: 'Code van Anthropic',
    send: 'Inloggen afronden',
    sent: 'Code controleren…',
    connected: 'Ingelogd{{who}}',
    plan: 'abonnement: {{plan}}',
    lastOk: 'laatst gecontroleerd {{when}}',
    expired:
      'Anthropic accepteert deze login niet meer. Log opnieuw in; gestopte runs kun je daarna laten verdergaan.',
    failed: 'Inloggen lukte niet ({{code}}). Probeer het opnieuw.',
    disconnect: 'Ontkoppelen',
    notUsedYet:
      'Claude Code-agents op deze provider betalen nog met een API-key. Zet ze over op dit account (een eventuele API-key blijft als reserve).',
    useForAgents: 'Gebruik dit account voor Claude Code-agents',
    disconnectConfirm: 'Je Claude-account ontkoppelen? Je agents stoppen er meteen mee.',
    unavailable: 'Inloggen met je eigen Claude-account staat op deze server niet aan.',
    agentsTitle: 'Agents op jouw account',
    agentsNone: 'Nog geen. Agents die jij maakt draaien vanzelf op jouw account.',
    chosen: 'door jou gekozen',
    addAgent: 'Ook een agent op mijn account laten draaien…',
    add: 'Toevoegen',
    removeAgent: 'Terug naar het account van de maker',
  },
  guardrails: {
    messagesTitle: "Berichten van collega's",
    readLateMessages: 'Berichten lezen die binnenkomen terwijl een run afrondt',
    readLateMessagesHint:
      'Normaal gaat een bericht dat binnenkomt terwijl de agent afrondt naar zijn volgende run. Aan: de run gaat nog één keer door om het te lezen (één extra modelbeurt, dus extra kosten). Alleen voor AI SDK-agents; Claude Code en Codex krijgen berichten tussen hun toolcalls door.',
    respondWhenMentioned: "Reageren op DM's en @mentions als de agent niet bezig is",
    respondWhenMentionedHint:
      'Aan: een DM of @mention van een collega (of jou) start een korte run zodat de agent antwoordt. Elke reactie kost een run en tokens; een ping-pong tussen twee agents stopt vanzelf. Uit: het bericht wacht tot de volgende run.',
  },
  companyPage: {
    openAgent: 'Agent openen',
    chat: 'Chatten',
    nowWorking: 'Nu bezig met',
    recentRuns: 'Recente runs',
    recentChats: 'Recente chats',
  },
  channels: {
    new: 'Nieuw kanaal',
    newTitle: 'Nieuw kanaal',
    manage: 'Kanaalinstellingen',
    manageTitle: 'Instellingen #{{slug}}',
    manageHint:
      'Leden kunnen posten met de tool company_channels. Agents die meelezen krijgen nieuwe berichten in hun context bij de start van een run (maximaal ~300 tokens).',
    slug: 'Kanaalnaam (bijv. launch)',
    name: 'Weergavenaam',
    topic: 'Onderwerp',
    members: 'Leden',
    readsAlong: 'leest mee',
    readsAlongFor: '{{name}} leest mee',
    tokenNote_one: '{{count}} agent leest mee: maximaal ~300 tokens per run, alleen als er iets nieuws is.',
    tokenNote_other:
      '{{count}} agents lezen mee: elk maximaal ~300 tokens per run, alleen als er iets nieuws is.',
    archive: 'Kanaal archiveren',
    emptyTitle: 'Nog geen kanalen',
    emptyHint:
      'In kanalen overleggen je agents met elkaar, zoals in Slack. Maak er een, voeg agents toe en geef ze de tool company_channels. Meelezen is optioneel, zodat het nooit ongemerkt tokens kost.',
    noPosts: 'Hier is nog niets gezegd.',
    compose: 'Bericht in #{{slug}} (gebruik @slug om een agent te noemen)',
    send: 'Versturen',
    fromRun: 'uit een run',
  },
  agentTabs: {
    overview: 'Overzicht',
    config: 'Configuratie',
    tools: 'Tools & beleid',
    triggers: 'Triggers',
    memory: 'Geheugen',
    runs: 'Runs',
    usage: 'Gebruik',
  },
  advanced: {
    changed: '{{count}} aangepast',
    reset: 'Standaard herstellen',
    basics: 'Basis',
    hintSteps: 'De run stopt na zoveel modelstappen.',
    hintCost: 'De run stopt voordat hij meer zou uitgeven dan dit.',
  },
  newAgent: {
    chooseHint: 'Begin met een kant-en-klare agent. Je kunt achteraf alles aanpassen.',
    blank: 'Leeg beginnen',
    blankHint: 'Schrijf zelf de instructies en kies zelf de tools.',
    changeTemplate: 'Ander template',
    createAndChat: 'Aanmaken en chatten',
    basics: 'Basis',
    advanced: 'Geavanceerde opties',
    advancedHint:
      'Slug, rol, manager, runtime, parameters, guardrails, tools en policies. De standaardwaarden zijn veilig.',
    budgetFailed: 'De agent is aangemaakt, maar het dagbudget kon niet worden opgeslagen.',
    designTitle: 'Beschrijf het — AI bouwt het',
    designHint:
      'Zeg wat de agent moet doen. AI kiest het beste sjabloon en schrijft het profiel; jij controleert alles voordat het wordt aangemaakt.',
    designPlaceholder:
      'bijv. Beantwoordt klantmails over bestellingen en maakt conceptantwoorden die ik goedkeur',
    designButton: 'Ontwerp met AI',
    designing: 'Bezig met ontwerpen…',
    designDone: 'Concept klaar · {{cost}}',
    designFrom:
      'Door AI opgesteld vanuit het sjabloon {{template}}. Controleer de instructies voordat je de agent aanmaakt.',
    designUnavailable: {
      no_key: 'Ontwerpen met AI is nu niet beschikbaar. Kies een sjabloon.',
      rate_limited: 'Je hebt dit uur veel met AI ontworpen. Probeer het later opnieuw of kies een sjabloon.',
      budget: 'Ontwerpen met AI heeft de limiet van vandaag bereikt. Kies een sjabloon.',
      error: 'Ontwerpen met AI lukte deze keer niet. Probeer het opnieuw of kies een sjabloon.',
    },
    orTemplate: 'Of begin met een sjabloon',
    firstTask: 'Voorgestelde eerste taak',
  },
  setupGate: {
    providerTitle: 'Koppel eerst een AI-provider',
    providerWhy:
      'Agents hebben een model nodig om mee te denken. Koppel één keer een provider; de modellen worden automatisch toegevoegd.',
    providerAsk:
      'Er is nog geen AI-provider gekoppeld. Vraag een eigenaar of beheerder van dit bedrijf om er een te koppelen.',
    modelsTitle: 'Zet eerst een model aan',
    modelsWhy: 'Er is een provider gekoppeld, maar geen van de modellen staat aan.',
    modelsAction: 'Modellen kiezen →',
    modelsAsk: 'Er staat nog geen model aan. Vraag een eigenaar of beheerder om er een aan te zetten.',
    agentTitle: 'Maak je eerste agent',
    agentWhy:
      'Chats, taken en flows worden door agents afgehandeld. Kies een kant-en-klare agent of beschrijf wat je nodig hebt.',
    agentAsk: 'Er zijn nog geen agents. Vraag een eigenaar of beheerder om er een te maken.',
  },
  onboarding: {
    title: 'Aan de slag',
    subtitle: 'Drie stappen van een lege werkruimte naar het eerste resultaat van je agent.',
    progress: '{{done}} van {{total}} klaar',
    continue: 'Verder met instellen',
    allDone: 'Alles staat klaar',
    hide: 'Checklist verbergen',
    open: 'Begeleide setup openen',
    next: 'Volgende stap',
    back: 'Terug',
    skip: 'Later',
    done: 'Klaar',
    stepOf: 'Stap {{n}} van {{total}}',
    steps: {
      provider: 'Provider toevoegen',
      models: 'Standaardmodellen kiezen',
      agent: 'Eerste agent maken',
      budget: 'Budget instellen',
      channels: 'Meldingen koppelen',
      hello: 'Zeg hallo',
    },
    desc: {
      provider:
        'Koppel Anthropic, OpenAI of een andere provider. We testen de sleutel en synchroniseren modellen met prijzen.',
      models:
        'Kies welke modellen agents mogen gebruiken. Voor achtergrondwerk raden we een goedkoop model aan.',
      agent:
        'Beschrijf wat je nodig hebt en AI bouwt het, of begin met een sjabloon. Beide met verstandige instructies, guardrails, tools en een budget.',
      budget: 'Begrens wat de hele organisatie per dag en per maand mag uitgeven.',
      channels: 'Ontvang goedkeuringen en meldingen via Telegram of pushmeldingen.',
      hello: 'Open een chat met je nieuwe agent en stuur een eerste bericht.',
    },
    cta: {
      provider: 'Provider toevoegen',
      models: 'Modellen kiezen',
      agent: 'Sjabloon kiezen',
      budget: 'Budget instellen',
      channels: 'Koppelen',
      hello: 'Chat openen',
    },
    addProviderFirst: 'Voeg eerst een provider toe →',
    noModels:
      'Nog geen modellen — voeg een provider toe; de modellen worden dan automatisch gesynchroniseerd.',
    apiKey: 'API-sleutel',
    baseUrl: 'Basis-URL',
    connect: 'Verbinden & modellen synchroniseren',
    signInChatgpt: 'Inloggen met ChatGPT',
    connecting: 'Verbinding testen…',
    syncing: 'Modellen en prijzen synchroniseren…',
    connected: 'Verbonden · {{count}} modellen gesynchroniseerd',
    testFailed: 'Verbinding mislukt: {{error}}',
    keyNote: 'Sleutels worden versleuteld opgeslagen en nooit meer getoond.',
    apiKeyOptional: 'API-sleutel (optioneel met een abonnement)',
    payTitle: 'Hoe je Claude-agents betaald worden',
    payKey: 'API-sleutel (aanbevolen voor 24/7)',
    payKeyHint:
      'Betaal per token, werkt voor elke runtime en voor achtergrondwerk. Heb je Claude Max? Gebruik je maandelijkse API-credits met een Console-key.',
    payLogin: 'Je eigen Claude-account',
    payLoginHint:
      'Claude Code-agents draaien in hun sandbox op je Claude-abonnement. Na het opslaan logt Claude Code in via de pagina van Anthropic. Een API-sleutel is optioneel als reserve.',
    subToken: 'Claude-abonnementstoken (optioneel)',
    subTokenHint:
      'Pro/Max-abonnement: voer `claude setup-token` uit en plak het sk-ant-oat01-…-token. Claude Code-agents draaien dan op je abonnement.',
    subDetected: 'Dat was een Claude-abonnementstoken: het is naar het abonnementsveld verplaatst.',
    payMode: {
      api_key: 'Afrekening: API-sleutel (per token).',
      subscription:
        'Afrekening: alleen Claude-abonnement. Agents moeten de Claude Code-runtime gebruiken; geheugensamenvattingen en ander achtergrondwerk hebben een API-sleutel nodig.',
      hybrid:
        'Afrekening: hybride. Claude Code-agents draaien op je abonnement en gaan verder op de API-sleutel als de limiet bereikt is.',
    },
    recommended: 'Aanbevolen voor achtergrondwerk',
    perMillion: '$ in / uit per 1M tokens',
    noPrice: 'geen prijs',
    enabledCount: '{{count}} ingeschakeld',
    template: 'Sjabloon',
    model: 'Model',
    runtime: 'Runtime',
    agentName: 'Naam',
    createAgent: 'Agent maken',
    budgetIncluded: 'Inclusief een agentbudget van {{amount}}/dag',
    daily: 'Daglimiet (USD)',
    monthly: 'Maandlimiet (USD)',
    saveBudget: 'Budget opslaan',
    budgetHint: 'Runs stoppen voordat ze een harde limiet overschrijden. Bij 80% krijg je een waarschuwing.',
    dailyTokens: 'Daglimiet (miljoen tokens)',
    monthlyTokens: 'Maandlimiet (miljoen tokens)',
    tokenHint:
      'Tokens = invoer (incl. cache) + uitvoer van elke modelaanroep. De eigen limieten van je Claude-abonnement gelden daarnaast.',
    budgetBilling: {
      subscription:
        'Je betaalt met een Claude-abonnement: runs kosten $0 per token, dus een dollarbudget raakt nooit vol. Begrens daarom tokens, zodat een op hol geslagen agent je abonnement niet opmaakt.',
      hybrid:
        'Hybride: de dollarlimieten gelden voor API-sleutelgebruik (terugval en achtergrondwerk); de tokenlimieten voor alle gebruik, inclusief het abonnement.',
    },
    channelsHint: 'Meldingskanalen staan in Instellingen. Koppel Telegram of zet push aan in deze browser.',
    openChannels: 'Meldingskanalen openen',
    helloAgent: 'Agent',
    helloSend: 'Zeg hallo',
    helloOpen: 'Chat openen',
    helloMessage: 'Hoi! Stel jezelf kort voor en vertel waarmee je me kunt helpen.',
    starters: {
      manager1:
        'Maak een plan om een nieuwsbrief te lanceren: welke agents hebben we nodig en wat doet elke agent als eerste?',
      manager2: 'Kijk welke agents we hebben en vertel me welke rol ontbreekt voor een klein contentteam.',
      manager3: 'Vat samen wat dit bedrijf nu kan en stel drie nuttige eerste taken voor.',
      researcher1:
        'Zoek de drie populairste tools om AI-agents te beheren en vergelijk ze in een korte brief met bronnen.',
      researcher2: 'Zoek uit wat concurrenten in mijn markt rekenen en vat het samen in een tabel.',
      researcher3:
        'Geef me een overzicht met bronnen van het laatste nieuws over AI-agents van de afgelopen week.',
      developer1:
        'Zet in de sandbox een klein TypeScript-project op met een test, draai het en laat me het resultaat zien.',
      developer2:
        'Schrijf een script dat alle bestanden in een map hernoemt naar kleine letters, test het en leg uit hoe je het gebruikt.',
      developer3: 'Controleer welke tools en talen in de sandbox beschikbaar zijn en rapporteer terug.',
      assistant1:
        'Schrijf een vriendelijk antwoord waarin ik een vergaderuitnodiging afwijs, in drie korte zinnen.',
      assistant2: 'Geef me een checklist om een klantpresentatie van 30 minuten voor te bereiden.',
      assistant3: 'Leg uit wat je voor me kunt doen en welke vragen je het best beantwoordt.',
      writer1:
        'Schrijf een vriendelijke nieuwsbriefintro van 150 woorden over ons nieuwe product, met twee kopopties.',
      writer2: 'Schrijf een LinkedIn-post over wat we dit kwartaal geleerd hebben, warm en eerlijk van toon.',
      writer3: 'Herschrijf deze tekst korter en duidelijker: (plak hier je tekst)',
      reviewer1:
        'Review de code in /workspace op bugs en beveiligingsproblemen en geef de vijf belangrijkste bevindingen.',
      reviewer2: 'Kijk welke delen van het project geen tests hebben en stel voor wat we eerst testen.',
      reviewer3:
        'Geef me een overzicht van hoe deze repository is opgebouwd en waar de risicovolle delen zitten.',
    },
    optional: 'Optioneel',
    startNow: 'Aanmaken en starten',
    firstTask: 'Eerste taak',
    firstTaskHint: 'Kies een suggestie of schrijf zelf iets. Je ziet het resultaat meteen in de chat.',
    advanced: 'Geavanceerde opties (model, runtime)',
    extrasTitle: 'Stel je werkruimte verder af',
    extrasSubtitle: 'Je eerste agent werkt. Deze optionele stappen maken het veiliger en handiger.',
    started: '{{name}} is aan het werk met je taak',
    needsAgent: 'Maak eerst een agent.',
    readOnly: 'Je rol mag dit niet wijzigen. Vraag een eigenaar of beheerder.',
  },
  ops: {
    title: 'Live operaties',
    subtitle: '{{agents}} agents · {{running}} aan het werk · {{approval}} wachten op goedkeuring',
    list: 'Lijst',
    office: 'Kantoor',
    view: 'Weergave',
    status: {
      running: 'Bezig',
      approval: 'Wacht op goedkeuring',
      idle: 'Inactief',
      paused: 'Gepauzeerd',
      failed: 'Mislukt',
    },
    noRun: 'Nog geen runs',
    lastRun: 'Laatste run {{when}}',
    spendToday: 'vandaag',
    runsToday_one: '{{count}} run vandaag',
    runsToday_other: '{{count}} runs vandaag',
    chat: 'Chat',
    openRun: 'Run openen',
    pause: '{{name}} pauzeren',
    resume: '{{name}} hervatten',
    approvalBadge_one: '{{count}} goedkeuring wacht',
    approvalBadge_other: '{{count}} goedkeuringen wachten',
    room: 'Team van {{name}}',
    executive: 'Directie',
    empty: 'Nog geen agents.',
    emptyCta: 'Maak je eerste agent →',
    filter: 'Agents filteren',
    liveHint: 'Live bijgewerkt',
  },
  hoverCard: {
    steps_one: '{{count}} stap',
    steps_other: '{{count}} stappen',
    openRun: 'Bekijk actieve run',
    openChat: 'Naar het gesprek',
    newChat: 'Chatten',
    activeRun: 'Actieve run van {{name}}',
  },
  inspector: {
    agentSettings: 'Instellingen voor {{name}}',
    agentSections: 'Agentonderdelen',
    agentUnavailable: 'Deze agent is niet beschikbaar of gearchiveerd.',
    sections: {
      config: 'Instellingen · model en instructies',
      permissions: 'Rechten',
      tools: 'Tools',
      mcp: 'Integraties (MCP)',
      triggers: 'Triggers',
      flows: 'Flows',
      skills: 'Vaardigheden',
      memory: 'Geheugen',
      runs: 'Runs',
      usage: 'Gebruik',
    },
    page: {
      runs: 'Runs op dit moment',
      active: 'Actief',
      waitingForYou: 'Wacht op jou',
      failedToday: 'Mislukt (24u)',
      costRunning: 'Kosten tot nu toe',
      runsBreakdown: '{{running}} bezig · {{queued}} in de wachtrij · {{scheduled}} wachten op een limiet',
      longest: 'Loopt het langst',
      nothingActive: 'Er loopt niets.',
      lines: 'Actieve rapportagelijnen',
      noLines: 'Op dit moment geeft geen enkele agent werk door aan een andere.',
      approvals: 'Wacht op een beslissing',
      nothingWaiting: 'Er wacht niets op jou.',
      pending: 'Openstaand',
      soonest: 'Verloopt over',
      byAgent: 'Per agent',
      byTool: 'Per actie',
      tasks: 'Takenwachtrij',
      open: 'Open',
      overdue: 'Te laat',
      tasksBreakdown: '{{running}} bezig · {{queued}} in de wachtrij',
    },
    label: 'Contextpaneel',
    scope: 'Context tonen voor',
    organization: 'Organisatie',
    focused: 'actief',
    collapse: 'Paneel inklappen',
    noAgents: 'Nog geen agents. Maak er een om hier live status, kosten en runs te zien.',
    noRuns: 'Nog geen runs.',
    sayHello: 'Zeg hallo tegen een agent →',
    createAgent: 'Maak je eerste agent →',
    addProvider: 'Voeg eerst een provider toe →',
    agentPaused: 'Gepauzeerd — begint geen nieuw werk.',
    lastActive: 'Niets te doen · laatst actief {{when}}',
    toolAccess: 'Toegang tot tools',
    cost14d: 'Kosten · laatste 14 dagen',
    responseTime: 'Gangbare duur van een run',
    success: 'gelukt',
    idle_one: '{{count}} agent zonder werk',
    idle_other: '{{count}} agents zonder werk',
    hero: {
      working_one: '{{count}} agent aan het werk',
      working_other: '{{count}} agents aan het werk',
      waiting_one: '{{count}} wacht op jou',
      waiting_other: '{{count}} wachten op jou',
      halted: 'Alle agents zijn stilgezet',
      sub_one: '{{count}} agent · {{spent}} uitgegeven vandaag',
      sub_other: '{{count}} agents · {{spent}} uitgegeven vandaag',
    },
    act: {
      working: 'Bezig…',
      thinking: 'Denkt na…',
      writing: 'Schrijft een antwoord…',
      tool: 'Gebruikt {{tool}}',
      delegating: 'Geeft werk door aan {{role}}',
      approval: 'Wacht op jouw goedkeuring',
      question: 'Heeft je een vraag gesteld',
      waitingChildren: 'Wacht tot zijn helpers klaar zijn',
      waitingOn: 'Wacht op {{names}}',
      queued: 'In de wachtrij, start zo',
      scheduled: 'Gepauzeerd tot een limiet vrijkomt',
    },
    needs: {
      title_one: 'Wacht op jou ({{count}})',
      title_other: 'Wacht op jou ({{count}})',
      approval: 'wil: {{tool}}',
      question: 'vraagt je iets',
      waiting: 'wacht op goedkeuring',
      review: 'Bekijken',
      answer: 'Beantwoorden',
      inbox: 'Goedkeuringen',
    },
    working: {
      title: 'Nu aan het werk',
      none: 'Er werkt nu niemand.',
    },
    today: {
      spent: 'Vandaag uitgegeven',
      ofBudget: '{{pct}}% van dagbudget',
      noBudget: 'geen dagbudget',
      done: 'Vandaag klaar',
      doneSub: 'runs afgerond',
      failed: 'Vandaag mislukt',
      failedSub: 'zie hieronder',
      allGood: 'alles goed',
    },
    recent: {
      title: 'Net klaar',
      all: 'Alle runs',
      done: 'rondde {{what}} af',
      failed: 'faalde bij {{what}}',
      stopped: 'stopte met {{what}}',
    },
    mode: { chat: 'een chatantwoord', task: 'een taak', subagent: 'een deeltaak' },
  },
  chats: {
    masterNoModel: 'Commando’s zoals /status werken nu; vragen hebben een AI-model nodig.',
    masterConnect: 'Koppel een provider →',
    title: 'Chats',
    new: 'Nieuwe chat',
    all: 'Alle chats',
    company: 'Bedrijfschat',
    companyHint: 'Vraag alles — het werk gaat naar de juiste agents',
    companyShort: 'Het hele bedrijf tegelijk',
    search: 'Zoek in chats…',
    none: 'Nog geen chats. Begin er een met “Nieuwe chat”.',
    noMatch: 'Geen chats gevonden.',
    waitingSubscription: '{{name}} wacht op de subscriptionlimiet',
    working: '{{name}} is bezig…',
    waitingForYou: 'Wacht op jou',
    newReply: 'Nieuw antwoord',
    unknownAgent: 'Agent',
    openSideBySide: 'Naast de huidige chat openen',
    openCount_one: '{{count}} chat open',
    openCount_other: '{{count}} chats open',
    closeAll: 'Alles sluiten',
    bucket: { today: 'Vandaag', yesterday: 'Gisteren', week: 'Afgelopen 7 dagen', older: 'Ouder' },
    startTitle: 'Met wie wil je praten?',
    startHint:
      'Kies een agent (of het hele bedrijf) en typ je bericht. Plak of sleep een screenshot erin om te laten zien wat je bedoelt.',
    pickAgent: 'Kies een agent',
    showAll: 'Toon alle {{count}} agents',
    showFewer: 'Toon minder',
    messageTo: 'Bericht aan {{name}}',
    placeholder: 'Bericht aan {{name}}…',
    paused: '{{name}} is gepauzeerd',
    recentWith: 'Recente chats met {{name}}',
    noAgents: 'Je hebt nog geen agents.',
    createAgent: 'Maak er een →',
  },
  home: {
    placeholder: 'Vraag {{name}} om de lancering te plannen…',
    placeholderNone: 'Maak een agent aan om te beginnen…',
    composer: 'Bericht voor {{name}}',
    send: 'Verstuur naar {{name}}',
    pickAgent: 'Agent: {{name}}. Kies een andere agent',
    starters: 'Voorbeeldprompt invoegen',
    starter1: 'Plan de productlancering van volgende maand en verdeel het werk over het team.',
    starter2: 'Vat samen wat elke agent vandaag deed en markeer wat vastzit.',
    starter3: 'Onderzoek onze drie grootste concurrenten en vergelijk hun prijzen.',
    runtime: 'Model en runtime',
    readOnly: 'Je rol kan geen chats starten.',
    halted: 'Agents zijn gestopt — hervat ze om te versturen.',
    sending: 'Chat starten…',
    quickActions: 'Snelle acties',
    greetingMorning: 'Goedemorgen',
    greetingAfternoon: 'Goedemiddag',
    greetingEvening: 'Goedenavond',
    status: '{{agents}} agents actief · {{running}} runs bezig',
    composerTitle: 'Nieuwe opdracht',
    to: 'Aan',
    sendLabel: 'Verstuur',
    quickActionsHint: 'Veelgebruikte plekken',
    actNewAgent: 'Nieuwe agent',
    actNewAgentDesc: 'Stel een agent samen met rol, tools en limieten',
    actTask: 'Taak aanmaken',
    actTaskDesc: 'Geef een agent een doel met een eigen planning',
    actTrigger: 'Trigger instellen',
    actTriggerDesc: 'Laat een agent starten op tijd of gebeurtenis',
    actMcp: 'MCP-koppelingen',
    actMcpDesc: 'Verbind externe tools en tokens',
    actMore: 'Alles doorzoeken',
    actMoreDesc: 'Open het zoekscherm voor elke pagina en actie',
  },
  skills: {
    title: 'Skills',
    subtitle:
      'Herbruikbare instructiebundels (open Agent Skills-formaat). Agents zien een regel per skill en laden hem pas als hij bij de taak past.',
    agentTab: 'Skills',
    agentHint:
      'Gekoppelde skills staan in de catalogus van deze agent. Wordt opgeslagen als nieuwe agentversie. Alleen live skills kun je koppelen.',
    agentNone: 'Nog geen live skills. Maak of importeer er een op de Skills-pagina.',
    noSandboxHint:
      'Skill-scripts kunnen alleen draaien als deze agent de sandbox-tools heeft (Tools & Policies).',
    new: 'Nieuwe skill',
    newTitle: 'Nieuwe skill',
    editTitle: '{{name}} bewerken',
    editHint:
      'SKILL.md in het open Agent Skills-formaat. Opslaan zet de nieuwe versie live voor elke agent die hem gebruikt.',
    import: 'Zip importeren',
    imported: '{{name}} geïmporteerd',
    export: 'Zip exporteren',
    archive: 'Archiveren',
    archiveTitle: '{{name}} archiveren?',
    archiveHint: 'Agents zien deze skill niet meer. De geschiedenis blijft bewaard.',
    archivedHint: 'Deze skill is gearchiveerd en onzichtbaar voor agents.',
    draftHint: 'Deze skill is een concept: hij is nog nooit live geweest.',
    none: 'Nog geen skills.',
    archived: 'Gearchiveerd',
    review: 'Wacht op review',
    reviewBanner_one:
      '{{count}} door een agent geschreven skill-wijziging wacht op jouw review. Agents gebruiken niets tot jij activeert.',
    reviewBanner_other:
      '{{count}} door agents geschreven skill-wijzigingen wachten op jouw review. Agents gebruiken niets tot jij activeert.',
    untrustedHint:
      'Dit voorstel is geschreven door een agent die onbetrouwbare invoer verwerkt (webpagina’s, e-mails, webhooks). Lees het goed voordat je activeert: er kunnen instructies van iemand anders in staan.',
    needsReview: 'Review nodig',
    proposal: 'Voorgestelde versie {{version}}',
    proposalHint: 'Geschreven door een agent. Geen enkele agent gebruikt dit tot jij het activeert.',
    activate: 'Activeren',
    activated: 'Skill-versie is live',
    reject: 'Afwijzen',
    rejected: 'Voorstel afgewezen',
    source: 'Bron',
    sources: { manual: 'Handmatig', import: 'Geïmporteerd', agent: 'Agent' },
    status: { draft: 'Concept', active: 'Actief', archived: 'Gearchiveerd' },
    versionState: { active: 'Live / eerder', proposed: 'Voorgesteld', rejected: 'Afgewezen' },
    live: 'live',
    attachedTo: 'Gebruikt door',
    notAttached: 'Nog aan geen enkele agent gekoppeld.',
    usage: {
      line: '{{exposures}}× aangeboden · {{loads}}× geladen in {{days}} dagen',
      rate: '{{pct}}% geladen',
      tokens: '~{{tokens}} tokens per run',
      lastLoaded: 'laatst geladen {{when}}',
      title:
        'Runs die de skill in hun catalogus zagen vs. runs die hem laadden. Elke run die hem aangeboden krijgt, betaalt de catalogustokens.',
      unused: '{{days}} dagen niet geladen',
      unusedHint:
        'Wel aangeboden, nooit geladen: kost catalogustokens zonder nut. Overweeg hem te archiveren.',
    },
    updated: 'Bijgewerkt',
    versions: 'Versies',
    changelog: 'Wijzigingen',
    files: 'Bestanden',
    noFiles: 'Geen extra bestanden.',
    addFile: 'Bestand',
    filePath: 'Bestandspad',
    fileContent: 'Bestandsinhoud',
    filesHint: 'Alleen tekstbestanden (scripts/, references/, …), max 1 MB per bestand.',
    editor: {
      guided: 'Begeleid',
      preview: 'Voorbeeld',
      source: 'SKILL.md',
      name: 'Naam',
      nameHint: 'Kleine letters, cijfers en streepjes. Hiermee laadt een agent de skill.',
      nameLocked: 'Een live skill behoudt zijn naam in alle versies.',
      description: 'Wanneer moet een agent hem gebruiken?',
      descHint:
        'Eén of twee zinnen: wat hij doet en wanneer je hem inzet. Agents zien alleen deze regel tot ze de skill laden.',
      descPlaceholder:
        'Maak het wekelijkse verkooprapport en plaats het in het teamkanaal. Gebruik bij vragen over de cijfers van vorige week.',
      instructions: 'Instructies',
      instructionsHint:
        'Bouw het op uit stappen, notities en code. Schrijf <plaatshouders> voor waarden die per taak verschillen.',
      noBlocks: 'Nog geen instructies — voeg een lijst met stappen toe om te beginnen.',
      blocks: { heading: 'Sectie', steps: 'Stappen', bullets: 'Lijst', text: 'Notitie', code: 'Code' },
      addSteps: 'Stappen',
      addBullets: 'Lijst',
      addSection: 'Sectie',
      addNote: 'Notitie',
      addCode: 'Code',
      addStep: 'Stap toevoegen',
      addBullet: 'Item toevoegen',
      step: 'Stap {{n}}',
      bullet: 'Item {{n}}',
      stepPlaceholder: 'Beschrijf wat er moet gebeuren… (Enter voegt de volgende stap toe)',
      bulletPlaceholder: 'Beschrijf het item…',
      headingPlaceholder: 'Titel van de sectie',
      textPlaceholder: 'Schrijf een notitie of wat achtergrond…',
      language: 'Taal',
      level: 'Kopniveau',
      moveUp: 'Omhoog',
      moveDown: 'Omlaag',
      remove: 'Verwijderen',
      removeBlock: 'Blok verwijderen',
      inputs: 'Invoer die deze skill verwacht',
      inputsHint: 'Waarden in <punthaken> vult de agent per taak zelf in.',
      tools: 'Tools die hij gebruikt (optioneel)',
      toolsHint: 'Alleen als hint: dit geeft nooit een tool. Het tool-beleid bepaalt wat een agent mag.',
      toolsPlaceholder: 'Voeg een tool toe + Enter',
      removeTool: '{{tool}} verwijderen',
      addScript: 'Script',
      addReference: 'Naslag',
      previewCatalog: 'Wat de catalogus een agent toont',
      previewEmpty: 'Er is nog niets om te tonen.',
      sourceHint: 'De ruwe SKILL.md. Wijzigingen hier en in de begeleide weergave blijven gelijk.',
      sourceInvalid:
        'SKILL.md heeft bovenaan een ---frontmatter nodig. Je laatste geldige versie blijft behouden.',
      errors: {
        name: {
          required: 'Geef de skill een naam.',
          format: 'Gebruik kleine letters, cijfers en enkele streepjes (max 64).',
        },
        description: {
          required: 'Geef aan wanneer een agent deze skill moet gebruiken.',
          long: 'Houd de beschrijving onder 1024 tekens.',
        },
        body: { required: 'Voeg minstens één stap of notitie toe.' },
      },
    },
    suggestions: {
      title: 'Voorgestelde skills',
      subtitle: 'Geleerd van herhaald werk. Geen enkele agent gebruikt iets voordat jij het toevoegt.',
      kind: { new: 'Nieuw', update: 'Wijziging' },
      auto: 'Automatisch geleerd',
      untrusted: 'Onbetrouwbare invoer',
      learned: '{{agent}} deed dit {{count}} keer op dezelfde manier.',
      proposedBy: 'Voorgesteld door {{agent}}.',
      showSteps: 'Toon de stappen',
      showChanges: 'Toon wat er verandert',
      add: 'Skill toevoegen',
      editAdd: 'Bewerk & voeg toe',
      dismiss: 'Negeren',
      added: 'Skill toegevoegd',
      dismissed: 'Suggestie genegeerd',
      giveTo: 'Ook aan {{agent}} geven',
      attachFailed: 'Skill toegevoegd, maar kon niet aan de agent gekoppeld worden: {{error}}',
      reviewTitle: '{{name}} bekijken',
      reviewHint:
        'Pas alles aan wat je wilt. Toevoegen zet hem live voor de agents waaraan hij gekoppeld is.',
    },
  },
  flows: {
    title: 'Flows',
    subtitle:
      'Doe een procedure één keer voor — agents herhalen hem met je integraties (MCP), waar mogelijk zonder model.',
    record: 'Opnemen',
    recordTitle: 'Procedure opnemen',
    recordHint:
      'Voer de procedure uit in Chrome met de Mandistry-recorder. Als je stopt, wordt elke stap gekoppeld aan je integraties (MCP); klikken in een browser is alleen het laatste redmiddel.',
    name: 'Wat neem je op?',
    namePlaceholder: 'bijv. Bug melden in Linear',
    targetAgent: 'Voor agent (optioneel)',
    anyAgent: 'Later kiezen',
    includeValues:
      'Ingevulde waardes opnemen als standaardwaarde (wachtwoorden, kaartnummers en eenmalige codes nooit)',
    start: 'Opname starten',
    extConnected: 'Recorder-extensie verbonden',
    extNotPaired: 'Recorder-extensie gevonden, nog niet verbonden met deze server',
    extMissing: 'Recorder-extensie niet gevonden',
    extInstall: 'Installeer de Chrome-extensie één keer (ongeveer een minuut); deze pagina ziet hem vanzelf.',
    extDownload: 'Extensie downloaden (.zip)',
    extStep1: 'Download de zip en pak hem uit (je krijgt een map mandistry-recorder).',
    extStep2: 'Open {{url}} in Chrome en zet Ontwikkelaarsmodus aan (rechtsboven).',
    extStep3: 'Klik op Uitgepakte extensie laden en kies de map mandistry-recorder.',
    extStep4: 'De instellingen van de extensie openen: vul {{origin}} in en klik op Allow & save.',
    extStep5: 'Kom terug naar deze pagina en klik op Extensie verbinden.',
    extCopy: 'Kopiëren',
    extCopied: 'Gekopieerd',
    extHelp: 'Stap-voor-stap uitleg',
    extConnect: 'Extensie verbinden',
    extPaired: 'Extensie verbonden',
    recordings: 'Opnames',
    noRecordings: 'Nog geen opnames.',
    noFlows: 'Nog geen flows — neem een procedure op om er een te maken.',
    status: {
      recording: 'neemt op',
      stopped: 'gestopt',
      synthesizing: 'flow bouwen',
      ready: 'klaar',
      failed: 'mislukt',
      draft: 'concept',
      active: 'actief',
      archived: 'gearchiveerd',
    },
    events: '{{count}} events',
    stop: 'Stoppen & flow bouwen',
    waiting: 'Wachten op events van de extensie… voer de procedure uit in een ander tabblad.',
    building: 'Flow bouwen: je stappen worden gekoppeld aan integraties…',
    openFlow: 'Flow openen',
    rebuild: 'Opnieuw bouwen',
    steps: 'Stappen',
    params: 'Parameters',
    prereqs: 'Nodig voordat hij kan draaien',
    noPrereqs: 'Klaar om te draaien — er ontbreekt niets.',
    kpiSteps: 'Stappen',
    kpiMcp: 'zonder model',
    kpiRunCost: 'Modelkosten per run',
    kpiSynth: 'Synthesekosten',
    kind: { mcp_call: 'MCP', llm: 'Model', ask_human: 'Mens', agent: 'Agent', browser: 'Browser' },
    prereq: {
      server_missing: 'Koppel de integratie {{name}}',
      server_needs_auth: 'Log opnieuw in bij {{name}}',
      write_access: 'Sta "{{tool}}" toe op {{name}} (schrijfrechten)',
      scope_missing: '{{note}}',
      unsupported_step:
        'Stap "{{step}}" heeft de browser-fallback nodig (nog niet beschikbaar) — koppel liever een integratie voor deze site',
    },
    fix: 'Oplossen',
    suggestTitle: 'Beste agent om dit te draaien',
    suggestNew: 'Geen goede match? Een eigen agent: {{runtime}} · {{model}}',
    attach: 'Koppelen',
    attached: 'Gekoppeld',
    attachedTo: 'Gekoppeld aan',
    reason: {
      covers_servers: 'heeft de integraties ({{detail}})',
      already_attached: 'al gekoppeld',
      deterministic: 'draait zonder model: geen tokenkosten',
      subscription: 'Claude-abonnement: $0 per token',
      cheap_model: 'goedkoop model',
      least_privilege: 'geen extra integraties',
      role_fit: 'rol past',
      no_tools_model: 'model kan geen tools aanroepen',
    },
    missing: {
      bind_server: 'krijgt {{detail}} bij koppelen',
      connect_server: 'koppel eerst {{detail}}',
      egress_host: 'heeft {{detail}} nodig op de egress-allowlist',
    },
    run: 'Uitvoeren',
    runTitle: '“{{name}}” uitvoeren',
    runStarted: 'Flow-run gestart',
    notAttached: 'Koppel de flow eerst aan een agent.',
    editJson: 'Stappen bewerken (JSON)',
    saveVersion: 'Opslaan als nieuwe versie',
    changelog: 'Wat is er veranderd?',
    versionSaved: 'Nieuwe versie opgeslagen',
    archive: 'Archiveren',
    source: 'uit opname',
    noParams: 'Geen parameters.',
    defaultValue: 'standaard',
    required: 'verplicht',
    agentTab: 'Flows',
    agentNone: 'Geen flows gekoppeld. Neem een procedure op via de Flows-pagina en koppel hem hier.',
  },
  common: {
    save: 'Opslaan',
    cancel: 'Annuleren',
    back: 'Terug',
    create: 'Aanmaken',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    remove: 'Verwijderen',
    add: 'Toevoegen',
    close: 'Sluiten',
    confirm: 'Bevestigen',
    loading: 'Laden…',
    retry: 'Opnieuw',
    search: 'Zoeken',
    all: 'Alle',
    none: 'Geen',
    name: 'Naam',
    status: 'Status',
    role: 'Rol',
    agent: 'Agent',
    model: 'Model',
    provider: 'Provider',
    cost: 'Kosten',
    tokens: 'Tokens',
    created: 'Aangemaakt',
    updated: 'Bijgewerkt',
    actions: 'Acties',
    yes: 'Ja',
    no: 'Nee',
    readOnly: 'Alleen-lezen: je rol mag dit niet wijzigen.',
    approve: 'Goedkeuren',
    deny: 'Weigeren',
    reason: 'Reden (optioneel)',
    stop: 'Stop',
    send: 'Versturen',
    today: 'Vandaag',
    from: 'Van',
    to: 'Tot',
    noData: 'Nog niets te zien.',
  },
  auth: {
    signIn: 'Inloggen',
    email: 'E-mail',
    password: 'Wachtwoord',
    remember: '7 dagen ingelogd blijven',
    passkey: 'Inloggen met passkey',
    or: 'of',
    twoFactor: 'Tweestapsverificatie',
    totpPrompt: 'Voer de 6-cijferige code uit je authenticator-app in.',
    emailCodeLink: 'Authenticator-app kwijt? Mail me een code',
    emailCodePrompt:
      'We hebben een 6-cijferige code gemaild naar het adres van je account. Hij is 15 minuten geldig en werkt één keer.',
    emailCode: 'Code uit je e-mail',
    emailCodeResend: 'Nieuwe code sturen',
    useAuthenticator: 'Authenticator-app gebruiken',
    verify: 'Verifiëren',
    trustDevice: 'Onthoud dit apparaat 7 dagen (geen code nodig)',
    back: 'Terug',
    tagline: 'een bedrijf van AI-agents',
  },
  setup: {
    title: 'Eerste installatie',
    step1: 'Owner-account',
    step2: 'Organisatie',
    step3: 'Tweestaps',
    step4: 'Passkey',
    name: 'Je naam',
    orgName: 'Naam organisatie',
    orgSlug: 'Slug',
    passwordHint: 'Minimaal 12 tekens.',
    next: 'Doorgaan',
    scanQr: 'Scan deze QR-code met je authenticator-app en voer daarna de 6-cijferige code in.',
    manualKey: 'Of voer deze URI handmatig in',
    backupCodes: 'Back-upcodes — bewaar ze veilig. Elke code werkt één keer.',
    addPasskey: 'Passkey toevoegen',
    skip: 'Later',
    done: 'Naar dashboard',
    passkeyHint: 'Met een passkey log je in met Touch ID, Windows Hello of een security key.',
  },
  pages: {
    company: 'Bedrijf',
    companySub: 'Live organogram — status, lopende taak en kosten van vandaag.',
    agents: 'Agents',
    newAgent: 'Nieuwe agent',
    chat: 'Chat',
    tasks: 'Taken',
    runs: 'Runs',
    flows: 'Flows',
    skills: 'Skills',
    approvals: 'Goedkeuringen',
    usage: 'Verbruik',
    notifications: 'Meldingen',
    settings: 'Instellingen',
  },
  agentCopy: {
    action: 'Dupliceren',
    title: '{{name}} dupliceren',
    hint: 'Een nieuwe agent met dezelfde inrichting: je keurt hier alles in één keer goed, niets hoeft opnieuw los goedgekeurd te worden.',
    submit: 'Kopie maken',
    takesOver: 'De kopie neemt over',
    basics: 'Instructies, rol, manager, model {{model}} en limieten (max {{steps}} stappen)',
    tools_one: '{{count}} ingebouwde tool of permissie',
    tools_other: '{{count}} ingebouwde tools en permissies',
    integrations_one: '{{count}} integratie (MCP)',
    integrations_other: '{{count}} integraties (MCP)',
    hosts_one: '{{count}} toegestane netwerkhost',
    hosts_other: '{{count}} toegestane netwerkhosts',
    rules: '{{count}} toolregels, {{skills}} skills, git-instellingen',
    notCopied: 'Niet gekopieerd: triggers, geheugen, workspaces en rungeschiedenis.',
  },
  talk: {
    overview: 'Overzicht',
    search: 'Zoek kanalen, mensen en berichten…',
    messages: 'Berichten',
    channels: 'Kanalen',
    noChannels: 'Nog geen kanalen. Agents maken ze zelf aan als ze iets moeten afstemmen.',
    people: 'Agents',
    agentDms: 'Gesprekken tussen agents',
    recentChats: 'Jouw recente chats',
    presence: {
      running: 'aan het werk',
      approval: 'wacht op jou',
      idle: 'beschikbaar',
      failed: 'beschikbaar (laatste run mislukt)',
      paused: 'gepauzeerd',
    },
    markRead: 'Markeren als gelezen',
    markUnread: 'Markeren als ongelezen',
    replying: 'Iemand is aan het antwoorden',
    typing: 'typt…',
    openInChat: 'Openen in chat →',
    openRun: 'run bekijken',
    fromRun: 'uit een run',
    person: 'mens',
    replies_one: '{{count}} antwoord',
    replies_other: '{{count}} antwoorden',
    replyInThread: 'Antwoorden in thread',
    mention: 'Agent noemen',
    isReplying_one: '{{names}} is aan het antwoorden…',
    isReplying_other: '{{names}} zijn aan het antwoorden…',
    thread: 'Thread',
    replyPlaceholder: 'Antwoord in de thread (@slug om iemand te noemen)',
    notFound: 'Dit kanaal bestaat niet (meer).',
    dmHint: 'Privégesprek tussen twee agents. Jij leest mee.',
    createdBy: 'gemaakt door {{name}}',
    temporary: 'tijdelijk',
    anAgent: 'een agent',
    temporaryHint:
      'Tijdelijk afstemmingskanaal, geopend door {{name}}. Het blijft open zodat je kunt volgen wat er is afgesproken; sluit het als het werk klaar is.',
    temporaryClosed: 'Dit afstemmingskanaal is gesloten. Het gesprek blijft bewaard.',
    closeChannel: 'Kanaal sluiten',
    dmEmpty: 'Deze agents hebben elkaar nog niets gestuurd.',
    dmPlaceholder: 'Schrijf mee in {{name}} (@slug om een agent te bereiken)',
    sys: {
      created: '{{who}} maakte dit kanaal',
      createdWith: '{{who}} maakte dit kanaal met {{others}}',
      added: '{{who}} voegde {{others}} toe',
      joined: '{{who}} kwam erbij',
      delegated: '{{who}} gaf {{to}} een taak: {{title}}',
      reported: '{{who}} rondde de taak af: {{text}}',
      reportedFailed: '{{who}} kon de taak niet afronden: {{text}}',
      replyFailed: '{{who}} kon niet antwoorden',
      stopped: {
        agent_turns: 'Gepauzeerd: agents reageerden te vaak op elkaar. Noem een agent om verder te gaan.',
        chain_depth: 'Gepauzeerd: dit gesprek raakte de maximale ketendiepte.',
        channel_rate: 'Gepauzeerd: te veel antwoorden in dit kanaal dit uur.',
      },
    },
  },
  broadcast: {
    open: 'Bericht naar meerdere agents',
    tabs: 'Open gesprekken',
    title: 'Bericht naar meerdere agents',
    description: 'Stuur één bericht naar maximaal {{max}} agents. Elk antwoord streamt in een eigen pane.',
    agents: 'Agents',
    message: 'Bericht',
    placeholder: 'Waar moeten ze naar kijken? (⌘/Ctrl+Enter om te versturen)',
    send: 'Stuur naar {{count}} agents',
    sent: 'Verstuurd naar {{count}} agents',
  },
  chat: {
    waitingSubscription: '{{name}} wacht op de reset van de subscriptionlimiet — esc om te stoppen',
    queuePlaceholder: '{{name}} is bezig — typ om een bericht in de wachtrij te zetten, esc om te stoppen',
    inboxQueued: 'In wachtrij',
    inboxDelivered: 'Bezorgd',
    inboxProcessed: 'Verwerkt',
    pickAgent: 'Agent',
    newConversation: 'Nieuw gesprek',
    conversations: 'Gesprekken',
    placeholder: 'Bericht aan {{name}}… (Enter om te versturen, Shift+Enter voor nieuwe regel)',
    empty: 'Kies een gesprek of begin een nieuw gesprek.',
    thinking: 'Denkt na',
    reasoning: 'Redenering',
    awaitingApproval: 'Wacht op goedkeuring',
    egressBlocked: 'Netwerk geblokkeerd',
    egressHint: 'De egress-proxy van de sandbox weigerde deze hosts (niet op de allowlist van de agent).',
    egressAllow: 'Toestaan voor deze agent',
    egressAllowed: 'toegestaan',
    egressGranted: '{{host}} toegevoegd aan de netwerk-allowlist van {{name}}',
    fallbackTitle: '{{from}} → {{to}}',
    fallbackUsageLimit:
      'De {{from}}-subscription heeft de usage limit bereikt. De run gaat verder op {{to}}.',
    fallbackRecovered: 'De oorspronkelijke subscription is weer beschikbaar: van {{from}} naar {{to}}.',
    fallbackCoolingDown:
      'De {{from}}-subscription koelt af na een usage limit. De run gaat verder op {{to}}.',
    fallbackActiveModel: 'Actief model: {{model}}',
    activeModel: 'Actief model',
    configuredModel: 'ingesteld: {{model}}',
    effort: 'effort {{level}}',
    fallbackBadge: 'fallback',
    fallbackToCodexTip: 'Claude-limiet bereikt, nu via Codex',
    fallbackToClaudeTip: 'Codex-limiet bereikt, nu via Claude',
    approvalTitle: 'Goedkeuring vereist',
    asksApproval: 'vraagt om goedkeuring',
    delegatedTo: 'Doorgegeven aan ',
    delegatedResume: 'gaat verder zodra het resultaat binnen is.',
    stopped: 'Gestopt',
    reconnecting: 'Opnieuw verbinden…',
  },
  runStatus: {
    queued: 'in wachtrij',
    running: 'bezig',
    scheduled: 'gepland',
    awaiting_approval: 'wacht op goedkeuring',
    awaiting_human: 'wacht op antwoord',
    waiting_children: 'wacht op sub-agents',
    completed: 'voltooid',
    failed: 'mislukt',
    cancelled: 'geannuleerd',
  },
  runs: {
    tabActive: 'Actief',
    tabAttention: 'Wacht op jou',
    tabFailed: 'Mislukt',
    tabAll: 'Alle',
    stopAll: 'Stop alle actieve ({{count}})',
    stopSelected: 'Stop geselecteerde',
    selected: '{{count}} geselecteerd',
    clearSelection: 'Wissen',
    confirmTitle: '{{count}} run(s) stoppen?',
    confirmBody:
      'Lopend werk wordt geannuleerd; afgeronde stappen en resultaten blijven bewaard. Taken en wachtende ouders worden voor je bijgewerkt.',
    confirmStop: 'Stop {{count}} run(s)',
    andMore: '…en nog {{count}}',
    stopped: '{{count}} gestopt, {{done}} waren al klaar',
    stopFailed: '{{count}} konden niet gestopt worden',
    downloadLogs: 'Logs downloaden',
    downloadLogsHint: 'Download geredigeerde log- en statusevents van deze run',
    scheduledReason: {
      usage_limit: 'Verbruikslimiet bereikt',
      plan_limit: 'Maandelijkse runs van je abonnement op',
      auth_required: 'Wacht op een nieuwe Claude-login',
    },
    loginRequiredHint:
      'Anthropic accepteert het Claude-account van deze agent niet meer. De voortgang is bewaard; de run gaat verder zodra de eigenaar Claude Code opnieuw laat inloggen (Instellingen › Providers).',
    provider: { claude: 'Claude', codex: 'Codex' },
    scheduledNote: '{{reason}}{{provider}} · hervat {{when}} ({{rel}})',
    planLimitHint:
      'Nieuwe runs wachten tot je volgende factuurperiode. Upgrade je abonnement en kies Verdergaan om hem nu te starten.',
    subscriptionUnavailable:
      'Er is geen subscriptionfallback beschikbaar. De voortgang is bewaard; deze run probeert automatisch opnieuw.',
    scheduledNoteAttempt: 'automatische hervatting {{n}}',
    scheduledHint:
      'De run is gepauzeerd met bewaarde voortgang. Hij gaat vanzelf verder zodra de limiet is gereset; voltooide stappen worden niet herhaald.',
    failedLimitTitle: 'Gestopt: verbruikslimiet opnieuw bereikt',
    failedLimitHint:
      'De automatische hervattingen zijn opgebruikt. De bewaarde voortgang blijft staan — "Verdergaan" gaat verder waar het stopte, zonder voltooide stappen te herhalen.',
    continue: 'Verdergaan',
    continueTitle: 'Nu verdergaan vanaf de bewaarde voortgang in plaats van op de reset te wachten',
    continued: 'Run gaat verder',
    restart: 'Opnieuw starten',
    restartTitle: 'Start een nieuwe run met dezelfde agent en input (deze run blijft zoals hij is)',
    restarted: 'Nieuwe run gestart',
    restartedFrom: 'herstart van {{id}}',
    allStatuses: 'Alle statussen',
    allAgents: 'Alle agents',
    count: '{{count}} runs',
    statusFilter: 'Statusfilter',
    agentFilter: 'Agentfilter',
  },
  approvals: {
    humanAccess: 'Extra toegang — menselijke goedkeuring',
    accessExecuted: 'Toegangsaanvraag uitgevoerd (gewijzigd/totaal)',
    needsYou: '{{count}} wachten op jou',
    allCaughtUp: 'Alles afgehandeld',
    emptyHint:
      'Als een agent een beslissing, antwoord of netwerktoegang nodig heeft, verschijnt dat hier en krijg je een melding.',
    statApprovals: 'Goedkeuringen',
    statQuestions: 'Vragen',
    statNetwork: 'Netwerkverzoeken',
    pending: 'Openstaand',
    decided: 'Besloten',
    expires: 'verloopt {{when}}',
    decideTitle: '{{action}} {{tool}}',
    questions: 'Vragen van agents',
    questionFrom: '{{agent}} stelt een vraag',
    questionWaiting: 'De agent wacht op je antwoord',
    answered: 'Beantwoord',
    answeredBy: 'beantwoord door {{who}} {{when}}',
  },
  notifications: {
    markRead: 'Markeer gelezen',
    markAllRead: 'Alles gelezen',
    unread: 'Ongelezen',
  },
  help: {
    title: 'Helpcentrum',
    subtitle: 'Tutorials, handleidingen en antwoorden over Mandistry.',
    searchPlaceholder: 'Zoek in het Helpcentrum of stel een vraag…',
    ask: 'Vraag het de AI',
    asking: 'Antwoord wordt geschreven…',
    answerTitle: 'Samenvatting',
    sources: 'Bronnen',
    readMore: 'Lees meer',
    usedArticles: 'Gebruikte artikelen ({{count}})',
    moreArticles: 'Meer artikelen ({{count}})',
    noResults: 'Geen artikelen gevonden. Probeer andere woorden of vraag het de assistent.',
    results: 'Artikelen',
    browse: 'Bladeren per onderwerp',
    tutorials: 'Tutorials',
    tutorialsHint: 'Stap-voor-stap uitleg, van je eerste agent tot opgenomen flows.',
    popularTutorials: 'Begin met een tutorial',
    otherArticles: 'Overige artikelen',
    articleCount_one: '{{count}} artikel',
    articleCount_other: '{{count}} artikelen',
    categoryNotFound: 'Dit onderwerp bestaat niet (meer).',
    typePlural: { tutorial: 'Tutorials', article: 'Artikelen', faq: 'Veelgestelde vragen' },
    all: 'Alle artikelen',
    back: 'Helpcentrum',
    otherLanguage: 'Dit artikel is nog niet in jouw taal beschikbaar.',
    helpful: 'Was dit nuttig?',
    yes: 'Ja',
    no: 'Nee',
    thanks: 'Bedankt voor je feedback.',
    related: 'Gerelateerde artikelen',
    notFound: 'Dit artikel bestaat niet of is niet meer beschikbaar.',
    updated: 'Bijgewerkt {{date}}',
    aiNoKey: 'AI-antwoorden zijn nu niet beschikbaar. Hier zijn de passende artikelen.',
    aiLimit: 'Je hebt de limiet per uur voor AI-antwoorden bereikt. Hier zijn de passende artikelen.',
    aiBudget: 'AI-antwoorden zijn vandaag gepauzeerd. Hier zijn de passende artikelen.',
    aiError: 'De assistent kon niet antwoorden. Hier zijn de passende artikelen.',
    cached: 'Opgeslagen antwoord',
    chatTitle: 'Hulpassistent',
    chatHint: 'Vraag hoe iets werkt. Antwoorden komen uit het Helpcentrum.',
    chatPlaceholder: 'Stel een vraag…',
    chatError: 'Het antwoord kon niet worden afgemaakt. Probeer het opnieuw.',
    incomplete: 'Dit antwoord is onvolledig. Probeer opnieuw om een nieuw antwoord te vragen.',
    chatRetry: 'Opnieuw proberen',
    chatSend: 'Verstuur',
    chatOpen: 'Open de hulpassistent',
    chatClose: 'Sluiten',
    chatNew: 'Nieuw gesprek',
    chatFull: 'Open volledige pagina',
    chatDisclaimer: 'Dit gesprek wordt opgeslagen om het Helpcentrum te verbeteren. AI kan fouten maken.',
    type: { article: 'Artikel', tutorial: 'Tutorial', faq: 'FAQ' },
  },
  settings: {
    providers: 'Providers',
    models: 'Modellen & prijzen',
    budgets: 'Budgetten',
    members: 'Leden & rollen',
    security: 'Beveiliging',
    audit: 'Auditlog',
    channels: 'Meldingskanalen',
    integrations: 'Integraties (MCP)',
    mcp: 'Claude Code (MCP)',
    knowledge: 'Kennis & Obsidian',
    company: 'Bedrijf',
  },
  company: {
    tabs: 'Bedrijfsweergaven',
    tab: { live: 'Live', org: 'Organogram' },
    filterStatus: 'Filter op status',
    legendRunning: 'bezig',
    legendApproval: 'wacht op goedkeuring',
    legendIdle: 'inactief',
    legendPaused: 'gepauzeerd',
    activeLines: '{{count}} actieve rapportagelijnen',
    tapHint: 'tik op een agent om hem te openen',
    clickHint: 'klik op een agent om hem te openen',
    permissions: 'Permissies',
    manageCompany: 'Het bedrijf beheren',
    manageCompanyHint:
      'Laat deze agent de agents onder zich aanmaken, aanpassen en archiveren (bijv. een CEO die het bedrijf uitbouwt). Elke wijziging vraagt standaard goedkeuring van een mens, tenzij een beleidsregel anders zegt. Hij kan alleen tools, integraties en limieten doorgeven die hij zelf heeft, en nooit deze permissie.',
    manageTriggers: 'Triggers beheren',
    manageTriggersHint:
      'Laat deze agent triggers van eigen medewerkers beheren met actuele permissiecontrole. Elke permanente agent kan eigen cron- en intervalschema’s beheren. Directe gebruikersverzoeken vragen onder standaardbeleid geen extra goedkeuring; expliciete regels en beveiliging voor onvertrouwde invoer blijven gelden. Eventwijzigingen en verwijderen behouden hun goedkeuringsbeleid. Agenttriggers vuren maximaal 12 keer per uur. Alleen een mens kan de managerpermissie toekennen.',
    unlocks: 'Ontsluit: {{tools}}',
    settingsIntro:
      'Agents met de permissie "Het bedrijf beheren" kunnen het bedrijf zelf uitbouwen: agents onder zich aanmaken, aanpassen en archiveren. Alleen een mens kan dit toekennen. Wijzigingen worden standaard door een mens goedgekeurd (zie Goedkeuringen) en altijd vastgelegd in het auditlog.',
    holders: 'Wie mag het bedrijf beheren',
    noHolders: 'Nog geen enkele agent heeft deze permissie.',
    grant: '{{name}} het bedrijf laten beheren',
    granted: '{{name}} kan nu het bedrijf beheren',
    revoked: '{{name}} kan het bedrijf niet meer beheren',
    needsAdmin: 'Alleen admins kunnen deze permissie wijzigen.',
  },
  permissionsPanel: {
    previewSummary: '{{count}} bekende acties kunnen een vraag opleveren.',
    previewIncomplete: '{{count}} integraties moeten nog gecontroleerd worden.',
    previewAlwaysReviewed:
      'Destructieve acties, betalingen, ontbrekende toegang en expliciete vraagregels blijven afzonderlijk beoordeeld.',
    possiblePrompts: 'Mogelijke vragen ({{count}})',
    automatic: 'Automatisch',
    asksPermission: 'Vraagt toestemming',
    blocked: 'Geblokkeerd',
    dependsOnTheAction: 'Hangt af van de actie',
    unavailableThroughThisBindingOr:
      'Niet beschikbaar via deze koppeling of serverinstelling. Pas toegang aan bij Integraties.',
    humanApprovalRequiredIncludingIn: 'Menselijke goedkeuring verplicht, ook in Auto.',
    extraCapabilitiesRequireApprovalLocal:
      'Extra rechten vragen toestemming. Lokale bestanden en opdrachten worden per actie gecontroleerd.',
    explicitAgentOrCompanyRule: 'Expliciete agent- of bedrijfsregel; gaat vóór Auto.',
    defaultForThisToolAnd: 'Standaard voor deze tool en uitvoeringsmodus.',
    aClarificationPausesWorkAuto:
      'Een inhoudelijke vraag pauzeert het werk. Auto gebruikt aannames waar dat kan.',
    summary:
      '{{allow}} acties draaien automatisch · {{ask}} kunnen om toestemming vragen · {{deny}} zijn geblokkeerd · {{rules}} eigen regels',
    whereMightThisAgentAsk: 'Waar kan deze agent om toestemming vragen?',
    checkBeforeStartingWorkThis:
      'Controleer dit vóór je werk start. Het overzicht gebruikt je huidige conceptinstellingen en dezelfde regels als de uitvoering.',
    execution: 'Uitvoering',
    standard: 'Standaard',
    networkLimitsAndPlanReview: 'Netwerk, grenzen en planbeoordeling',
    configureIntegrations: 'Integraties aanpassen',
    accessApprovedInAdvance: 'Vooraf toegestane toegang',
    sandboxNetworkHosts: 'Netwerkhosts in de sandbox',
    noneNewHostsRequireApproval: 'Geen; nieuwe hosts vragen toestemming.',
    directPushesToBranches: 'Rechtstreeks pushen naar branches',
    noneChangesGoThroughPull: 'Geen; wijzigingen via pull-/merge requests.',
    checkingPermissions: 'Permissies controleren…',
    planReviewIsEnabledA: 'Planbeoordeling staat aan. Een plan kan dus eerst op goedkeuring wachten.',
    accessByAction: 'Toegang per actie',
    searchActions: 'Zoek actie',
    searchAToolOrIntegration: 'Zoek een tool of integratie…',
    action: 'Actie',
    configure: 'Instellen',
    rule: 'Regel',
    configureAccess: 'Toegang aanpassen',
    toolSettings: 'Toolinstellingen',
    required: 'Verplicht',
    ruleFor: 'Regel voor',
    defaultInherit: 'Standaard / overnemen',
    allowAutomatically: 'Automatisch toestaan',
    alwaysAsk: 'Altijd vragen',
    block: 'Blokkeren',
    noActionsMatchThisFilter: 'Geen acties in dit filter.',
    connectedIntegrations: 'Gekoppelde integraties',
    toolListKnown: 'Toollijst bekend',
    discoverToolsInMcpFirst: 'Eerst tools ontdekken via MCP',
    reconnect: 'Opnieuw verbinden',
    disabled: 'Uitgeschakeld',
    readOnlyByDefaultIndividual: 'Standaard alleen lezen; individuele uitzonderingen kunnen ingesteld zijn.',
    integrationsUseTheLastDiscovered:
      'Integraties gebruiken de laatst ontdekte toollijst. Netwerktoegang, serverrechten en het gekozen doel worden bij uitvoering opnieuw gecontroleerd. Bestanden/bijlagen en vervolgwerk kunnen extra acties beschikbaar maken. Opslaan activeert je wijzigingen voor nieuwe runs; lopende runs behouden hun versie.',
  },
  bulkPermissions: {
    copyFrom: 'Neem gekozen conceptpermissies over van {{name}}.',
    saveFor: 'Opslaan voor {{count}} agents',
    executionStandardAuto: 'Uitvoering (Standaard / Auto)',
    replaceToolRules: 'Toolregels vervangen',
    replaceEnabledPlatformTools: 'Ingeschakelde platformtools vervangen',
    replaceAllowedNetworkHosts: 'Toegestane netwerkhosts vervangen',
    replaceDirectPushBranches: 'Directe pushbranches vervangen',
    permissionsSavedForSelectedAgents: 'Permissies opgeslagen voor de geselecteerde agents',
    applyToMultipleAgents: 'Toepassen op meerdere agents',
    changeGroupPermissions: 'Groepspermissies aanpassen',
    checkedSettingsWillBeReplaced:
      'De aangevinkte instellingen worden vervangen. Elke agent krijgt een nieuwe actieve versie. Instructies, modellen en overige instellingen blijven behouden. Lopende runs behouden hun versie. De groep is een selectie op rol; toekomstige agents worden niet automatisch aangepast.',
    whichSettings: 'Welke instellingen?',
    viewNewValues: 'Nieuwe waarden bekijken',
    whichAgents: 'Welke agents?',
    roleType: 'Rol / type',
    allRoles: 'Alle rollen',
    searchAgents: 'Agents zoeken',
    searchEGDeveloper: 'Zoek bijvoorbeeld developer…',
    selectVisibleAgents: 'Selecteer getoonde agents',
    clearSelection: 'Selectie wissen',
    noAgentsFound: 'Geen agents gevonden.',
    selected: 'Geselecteerd',
  },
};
